import { FC } from "react";

import { useT, FormattedMessage } from "src/internationalization";

import { ConfirmActionModal } from "./ConfirmActionModal";
import { ModalError, ModalSize } from "./Modal.types";

export type ConfirmDeactivateModalProps = {
  resourceName: string;
  onConfirm?: () => void;
  onClose?: () => void;
  loading?: boolean;
  size?: ModalSize;
  error?: ModalError;
  subtitle?: string;
};

export const ConfirmDeactivateModal: FC<ConfirmDeactivateModalProps> = ({
  resourceName,
  onConfirm,
  onClose,
  loading,
  size = "sm",
  error,
  subtitle,
}) => {
  const t = useT();

  return (
    <ConfirmActionModal
      danger
      title={
        <FormattedMessage id="component.modal.confirm.disable.heading" values={{ resourceName }} />
      }
      onConfirm={onConfirm}
      onClose={onClose}
      loading={loading}
      closeOnEscape={true}
      closeOnOutsideClick={true}
      confirmButtonText={t("component.modal.confirm.disable.primary.button")}
      size={size}
      error={error}
      subtitle={subtitle}
    >
      <div className="text-base text-textPrimary whitespace-pre-wrap">
        <FormattedMessage
          id="component.modal.confirm.disable.message"
          values={{
            resourceName,
          }}
        />
      </div>
    </ConfirmActionModal>
  );
};
